export default __webpack_public_path__ + "static/media/bookos-bold-italic.8e0be5c2.ttf";